import React, { useState, useEffect } from "react";
import styles from "./style.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
const SearchInput = (props = {}) => {
    const { value, onChange, style, inputClass, iconClass, placeholder } = props;
    const [inputVal, updateInputVal] = useState(value);
    useEffect(() => {
        if (value !== inputVal) {
            updateInputVal(value);
        }
    }, [value]);
    const handleClear = () => {
        updateInputVal("");
        if (onChange) {
            onChange("");
        }
    };
    return (React.createElement("div", { className: styles.searchBox, style: style ? style : {} },
        React.createElement("div", { className: styles.searchIcon },
            React.createElement(FontAwesomeIcon, { icon: faSearch })),
        React.createElement("input", { value: inputVal, className: styles.input + " " + (inputClass ? inputClass : ""), onChange: (event) => {
                const currValue = event.target.value;
                updateInputVal(currValue);
                if (onChange) {
                    onChange(currValue);
                }
            }, placeholder: placeholder ?? "Search..." }),
        (inputVal?.length ?? 0) > 0 && (React.createElement("div", { className: styles.closeIcon + " " + (iconClass ? iconClass : ""), onClick: () => handleClear() },
            React.createElement(FontAwesomeIcon, { icon: faTimesCircle })))));
};
export default SearchInput;
